import { Plan } from "@back4app2/sdk";
import { useNavigate } from "react-router-dom";

const PlanWidget = ({ plan, appId, freePlanUsageHours }: { plan?: Plan, appId: string, freePlanUsageHours?: number }) => {
  const navigate = useNavigate();
  let planRAM = '';
  if (plan?.maxRAM) {
    planRAM = plan.maxRAM >= 1024 ? `${plan.maxRAM / 1024}GB` : `${plan.maxRAM}MB`;
  }
  return <div className="rounded p-3 small:py-3 small:px-4 overflow-hidden bg-white/[0.06] w-full h-full">
    <div className="flex justify-between items-center mb-6">
      <span className='uppercase text-lg leading-140'>{plan?.name} plan</span>
      <button onClick={() => navigate(`/apps/${appId}/settings#general-settings`)} className="border rounded-[5px] border-cta-green text-cta-green inline-block py-2 px-2.5 text-xs font-medium leading-140">Upgrade</button>
    </div>
    <div className="flex justify-between gap-2 items-center mb-2">
      <span className="text-sm">1 {plan?.name} Container</span>
      <span className="text-xs text-light-blue max-w-[50%]">{planRAM} {plan?.maxCPU} CPU</span>
    </div>
  </div>
}

export default PlanWidget;